module.exports = __webpack_public_path__ + "assets/HexagonBySideDetailed.c81c16f4f7580489688641d0cbdb53d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/HexagonBySideDetailed.png
// module id = 521
// module chunks = 0